const { REACT_APP_WS_URI, REACT_APP_API_URI, REACT_APP_LOGROCKET_DOMAIN, REACT_APP_LOGROCKET_ENABLED } = process.env;

export const API_URI = REACT_APP_API_URI;
export const WS_URI = REACT_APP_WS_URI;
export const LOGROCKET_DOMAIN = REACT_APP_LOGROCKET_DOMAIN;
export const LOGROCKET_ENABLED = REACT_APP_LOGROCKET_ENABLED;
